import React, { Component, Suspense } from "react";

import { casteoSesion, datosSesion } from "../utils/types";
export const handlehome = () => {
    window.location.href = process.env.REACT_APP_ROUTER_BASE || "admin/home";
};

export const cerrarSession = () => {
    removeUserSession();
    console.log("redirigir fuera");
    window.location.href = "/";
};
export const removeUserSession = () => {
    sessionStorage.removeItem("tokenRefresh");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
};

export const getUser = () => {
    const userStr = sessionStorage.getItem("user");

    return userStr ? JSON.parse(userStr) : datosSesion;
};

export const getCodigoUsuario = () => {
    const userStr = sessionStorage.getItem("user");
    const obj = userStr ? JSON.parse(userStr) : datosSesion;
    return obj.codigo;
};

export const getCodigoIfip = () => {
    const userStr = sessionStorage.getItem("user");
    //console.log(userStr);
    const obj = userStr ? JSON.parse(userStr) : datosSesion;
    return obj.ifip.codigo;
};

export const guardarSesion = (datosUsuario, token, tokenR) => {
    console.log("guarda Sesion");
    console.log(JSON.stringify(datosUsuario));
    sessionStorage.setItem("tokenRefresh", tokenR);
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("user", JSON.stringify(datosUsuario));
};
export const setUserSessionRefresh = (user, token, tokenR) => {
    let datosUsuario = casteoSesion(user);
    guardarSesion(datosUsuario, token, tokenR);
};
export const getToken = () => {
    return sessionStorage.getItem("token") || null;
};
export const getTokenRefresh = () => {
    return sessionStorage.getItem("tokenRefresh") || null;
};